import { SpaceSelectCompass } from "@circle-react-shared/SpaceSelectCompass";
import { SpaceTrigger } from "@circle-react/components/QuickPostV3/Composer/SpaceTrigger";
import { TopicsTrigger } from "@circle-react/components/QuickPostV3/Composer/TopicsTrigger";
import {
  SPACE_SELECT_DROPDOWN_MAX_HEIGHT,
  SPACE_SELECT_DROPDOWN_MAX_WIDTH,
} from "@circle-react/components/QuickPostV3/constants";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";

export const TopSpaceSelect = () => {
  const {
    helpers: { basicSpacesWithPostCreationAllowed },
  } = useSpacesContext();

  return (
    <div className="mx-auto flex w-full max-w-3xl shrink-0 items-center justify-between gap-2 px-6 pb-4 lg:pt-5">
      <div className="shrink-0">
        <SpaceSelectCompass
          spaces={basicSpacesWithPostCreationAllowed()}
          name="space_id"
          trigger={<SpaceTrigger isMd asButton />}
          dropdownMaxWidth={SPACE_SELECT_DROPDOWN_MAX_WIDTH}
          dropdownMaxHeight={SPACE_SELECT_DROPDOWN_MAX_HEIGHT}
        />
      </div>
      <TopicsTrigger />
    </div>
  );
};
